module.exports = __webpack_public_path__ + "img/Pablo-Serrano-Poster-02.1e74cce3.jpg";